export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["If you cancel the trade, it will be closed without completing the operation."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to cancel the trade?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes, Cancel"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, Keep Active"])}
}